import { Categories, Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("product-list", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("productList")
      ) {
        return {
          type: "product-list",
        };
      }
    },
    model: {
      toHTML() {
        let rootElement = this.view?.el || this.getEl();
        if (!rootElement) return "";
        let outerHTML = rootElement.outerHTML;
        let productListType = this.getAttributes().type;
        let Category = this.getAttributes().category;
        let Collection = this.getAttributes().collection;
        let Product = this.getAttributes().product;

        if (!productListType && !Category && !Collection && !Product) {
          return outerHTML;
        }
        if (productListType === "category") {
          outerHTML = outerHTML.replace(
            /<!--\s*{%\s*products\s+"[^"]+"\s+[^%]+\s+as\s+products_dict\s*%}\s*-->/,
            `{% products '${productListType}' '${Category}' as products_dict %}`
          );
        } else if (productListType === "collection") {
          outerHTML = outerHTML.replace(
            /<!--\s*{%\s*products\s+"[^"]+"\s+[^%]+\s+as\s+products_dict\s*%}\s*-->/,
            `{% products '${productListType}' '${Collection}' as products_dict %}`
          );
        } else {
          outerHTML = outerHTML.replace(
            /<!--\s*{%\s*products\s+"[^"]+"\s+[^%]+\s+as\s+products_dict\s*%}\s*-->/,
            `{% products '${productListType}' '${Product}' as products_dict %}`
          );
        }
        return outerHTML;
      },
      defaults: {
        traits: [
          {
            type: "select",
            label: "Type",
            name: "type",
            options: [
              { id: "category", name: "Category" },
              { id: "collection", name: "Collection" },
              { id: "similar", name: "Similar" },
            ],
          },
          {
            type: "select",
            label: "Category",
            name: "category",
            options: [],
          },
          {
            type: "select",
            label: "Collection",
            name: "collection",
            options: [],
          },
          {
            type: "select",
            label: "Product",
            name: "product",
            options: [],
          },
        ],
        productListType: "",
        Category: "",
        Collection: "",
        Product: "",
        tagName: "div",
        classes: ["productList"],
        components: /*html*/ `
          <section class="md:my-10 mt-4 container mx-auto px-4">
            <!-- {% products "type" type_id as products_dict %} -->
              <div
                class="flex items-center justify-between mx-3 md:mx-0 md:mb-6 mb-3 "
              >
                <div class="flex items-center gap-x-2">
                  <div
                    class="border-s-4 border-[var(--primary)] md:h-7 h-5 relative"
                  ></div>
                  <h2
                    class="text-xl font-medium md:font-semibold font-montserrat md:text-3xl"
                  >
                    <!-- {% comment %} -->
                    Product
                    <!-- {% endcomment %} -->
                    <!-- {% if products_dict.query %}
                      Search results for '{{ products_dict.query }}'
                    {% elif products_dict.category_name %}
                    {{ products_dict.category_name }}
                    {% else %}
                    Product
                    {% endif %} -->
                  </h2>
                </div>
                <a href="/#" class="md:hidden">
                  <p class="text-[var(--primary)]">See All</p>
                </a>
              </div>
              <!-- {% if not products_dict.products %} -->
              <!-- <p> No products found !! </p>-->
              <!-- {% else %} -->
              <div
                class="grid grid-cols-2 gap-x-4 md:grid-cols-4 xl:grid-cols-5 md:gap-x-12 xl:gap-x-18 gap-y-6"
              >
                <!-- {% for product in products_dict.products %} -->
                <!-- {% comment %} -->

                <div
                  class="w-full rounded-lg shadow-lg border border-gray-300 overflow-hidden transition-transform duration-300 hover:scale-105  cursor-pointer relative overfow-hidden ripple-effect"

                >
                  <!-- {% endcomment %} -->

                  <!-- <div
                  class="rounded-lg shadow-lg border border-gray-300 overflow-hidden transition-transform duration-300 hover:scale-105 cursor-pointer relative overfow-hidden ripple-effect"
                > -->
                  <a class="w-full"
                     href="{{ product.absolute_url }}">
                    <div
                      class="md:px-4 md:pt-4 px-2 pt-2 flex flex-col items-center "
                    >
                      <!-- {% comment %} -->
                      <img
                        src="https://via.placeholder.com/150"
                        alt="Product Image"
                        class="rounded-t-lg  w-full md:h-40 mb-2 h-32 object-cover"
                      />
                      <!-- {% endcomment %} -->
                      <!-- <img
                        src="{% generate_thumbnail product.image_url '200x200/filters:format(webp)' %}"
                        alt="{{ product.name }}"
                        class="rounded-t-lg  w-full md:h-40 mb-2 h-32 object-cover"/> -->
                    </div>
                    <div class="md:px-4 px-2">
                    <p
                      class="md:text-lg  text-base font-semibold w-full truncate"
                    >
                      <!-- {% comment %} -->
                      Clothing
                      <!-- {% endcomment %} -->
                      <!-- {{ product.name }} -->
                    </p>
                    <p class="text-sm italic line-clamp-2 w-full min-h-10 ">
                      <!-- {% comment %} -->
                      this is test
                      <!-- {% endcomment %} -->
                      <!-- {{ product.short_desc }} -->
                    </p>
                    <p class="text-[var(--primary)] w-full">
                      Rs.
                      <!-- {% comment %} -->
                      4000
                      <!-- {% endcomment %} -->
                      <!-- {{ product.selling_price_range }} -->
                    </p>
                    </div>
                  </a>
                  <a
                    class="cursor-pointer relative overflow-hidden"
                    href="/checkout?product_slug={{ product.slug }}&quantity=1"
                  >
                    <p class="bg-[var(--primary)] text-white py-2 w-full text-center">
                    Buy now
                    </p>
                  </a>
                </div>
                <!-- {% endfor %} -->
              </div>
              <!-- {% endif %} -->
              <!-- {% comment %} -->
              <div class="flex w-full justify-center mt-4">
                <button class="text-red-400">Load More...</button>
              </div>
              <hr class=" my-2 border-gray-400" />
            <!-- {% endcomment %} -->
          </section>
        `,
      },
      async init() {
        this.loadTraitOptions();
        this.listenTo(this, "change:attributes:type", this.handleSelect);
        this.listenTo(this, "change:attributes:category", this.handleSelect);
        this.listenTo(this, "change:attributes:collection", this.handleSelect);
        this.listenTo(this, "change:attributes:product", this.handleSelect);
      },
      async loadTraitOptions() {
        const productResponse = await getApiData(APIS.PRODUCT, {});
        const categoryResponse = await getApiData(APIS.CATEGORY, {
          type: "category",
        });
        const collectionResponse = await getApiData(APIS.COLLECTION, {
          type: "collection",
        });
        this.set({
          traits: [
            {
              type: "select",
              label: "Type",
              name: "type",
              options: [
                { id: "category", name: "Category" },
                { id: "collection", name: "Collection" },
                { id: "similar", name: "Similar" },
              ],
            },
            {
              type: "select",
              label: "Category",
              name: "category",
              options: categoryResponse?.data ?? [],
            },
            {
              type: "select",
              label: "Collection",
              name: "collection",
              options: collectionResponse?.data ?? [],
            },
            {
              type: "select",
              label: "Product",
              name: "product",
              options: productResponse?.data ?? [],
            },
          ],
        });
      },

      handleSelect() {
        this.addAttributes({ productListType: this.getAttributes().type });
        this.addAttributes({ Category: this.getAttributes().category });
        this.addAttributes({ Collection: this.getAttributes().collection });
        this.addAttributes({ Product: this.getAttributes().product });
        this.loadTraitOptions();
      },
    },
  });
};
